import * as api from '@/api'

const shopDetail = {
  namespaced: true,
  state: {
    shopId: null,
    shopName: '',
    seatCount: -1,
    soStatus: false,
    shopOrderLimit: -1,
    seatOrderLimit: -1,
    preOrderLimit: -1,
    lastOrder: '',
    openAt: '',
    closeAt: '',
    sideMenuBikkuraponGameEnabled: -1, // 管理画面のスマホでビッくらポン>全体設定の値 ※事前注文で利用
    bikkuraponInstalled: -1, // ビッくらポンが店舗に設置されているか ※事前注文で利用
    priceDisplayEnabled: -1, // 価格表示設定 ※事前注文で利用
    bikkuraponIconDisplayEnabled: -1, // ビッくらポンアイコン表示設定 ※事前注文で利用

    isFetching: false,
    error: null,
  },
  getters: {
    getShopId: (state) => {
      return state.shopId
    },
    getSideMenuBikkuraponEnabled: (state) => {
      return state.sideMenuBikkuraponGameEnabled
    },
    getBikkuraponInstalled: (state) => {
      return state.bikkuraponInstalled
    },
    getPriceDisplayEnabled: (state) => {
      return state.priceDisplayEnabled
    },
    getBikkuraponIconDisplayEnabled: (state) => {
      return state.bikkuraponIconDisplayEnabled
    },
    getIsBikkuraponIconDisplay: (state) => {
      return (
        state.bikkuraponIconDisplayEnabled === 1 &&
        state.bikkuraponInstalled === 1 &&
        state.sideMenuBikkuraponGameEnabled === 1
      )
    },
    getError: (state) => {
      return state.error
    },
  },
  actions: {
    fetchShopDetail: async ({ commit, dispatch }, shopId) => {
      try {
        commit('getShopDetailStart', data)
        const { data } = await api.fetchShopDetail(shopId)

        dispatch('seat/setShopName', data.name, { root: true })
        dispatch('seat/setShopLastOrderTime', data.lastOrder, { root: true })

        commit('getShopDetailDone', data)
      } catch (error) {
        commit('getShopDetailFailed', error)
      }
    },
  },
  mutations: {
    getShopDetailStart(state) {
      state.error = null
      state.isFetching = true
    },
    getShopDetailDone(state, payload) {
      state.shopId = payload.id
      state.shopName = payload.name
      state.seatCount = payload.seatCount
      state.soStatus = payload.soStatus
      state.shopOrderLimit = payload.shopOrderLimit
      state.seatOrderLimit = payload.seatOrderLimit
      state.preOrderLimit = payload.preOrderLimit
      state.lastOrder = payload.lastOrder
      state.openAt = payload.openAt
      state.closeAt = payload.closeAt
      state.sideMenuBikkuraponGameEnabled = payload.sideMenuBikkuraponGameEnabled
      state.bikkuraponInstalled = payload.bikkuraponInstalled
      state.priceDisplayEnabled = payload.priceDisplayEnabled
      state.bikkuraponIconDisplayEnabled = payload.bikkuraponIconDisplayEnabled

      state.isFetching = false
    },
    getShopDetailFailed(state, error) {
      state.error = error
      state.isFetching = false
    },
  },
}

export default shopDetail
